module.exports = __webpack_public_path__ + "static/media/02.046f909a.png";